import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=664bbc81&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=664bbc81&prod&scoped=true&lang=css"
import style1 from "./SideNav.vue?vue&type=style&index=1&id=664bbc81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664bbc81",
  null
  
)

export default component.exports